/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Auth, I18n, Logger } from 'aws-amplify';
import React from 'react';
import { ButtonRow, InputRow, MessageRow, SectionBody } from '../AmplifyUI';
import AuthPiece from './AuthPiece';
import ConfirmationDialog from '../../components/ConfirmationDialog';
import * as CONFIG from '../../api/config';

const logger = new Logger('ConfirmSignUp');
const recreate = CONFIG.QRVerifyUrl + '/recreate';

export default class ConfirmSignUp extends AuthPiece {
    constructor(props) {
        super(props);
        this._validAuthStates = ['confirmSignUp'];
        this.confirm = this.confirm.bind(this);
        this.resend = this.resend.bind(this);
        this.userExists = this.userExists.bind(this);
        this.state = { openConfirmDialog: false,resendmsg : [],regAgain:false };
    }

    componentDidMount() {
        this.setState({ regAgain: false,resendmsg : []})
    }

    confirm() {
        const username = this.usernameFromAuthData() || this.inputs.username;
        const { code } = this.inputs;
        Auth.confirmSignUp(username, code)
            .then(() => this.changeState('signedUp'))
            .catch(err => this.error(err));
    }

    confirmLeaving() {
        this.setState({
            openConfirmDialog: true
        })
    }

    userExists(){
        const username = this.usernameFromAuthData() || this.inputs.username;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "username": username,
                "delete": true
            })
        };
        if(this.state.regAgain){
            fetch(recreate, requestOptions).then(response => response.json())
            .then(result => {
                if(result.status != "failure"){
                    this.setState({ regAgain: false,resendmsg : []})
                    this.changeState('signUp')
                }else{
                    this.error('We apologize for any inconvenience caused, but unfortunately the system is currently not available. Please try again later.');
                }
            }).catch(e => {
                this.error('We apologize for any inconvenience caused, but unfortunately the system is currently not available. Please try again later.');
            });
        } 
         
    }

    resend() {
        const username = this.usernameFromAuthData() || this.inputs.username;
        Auth.resendSignUp(username)
            .then((res) => {
                logger.debug('code resent');
                console.log(res)
                this.setState({resendmsg:res,regAgain:true})
            })
            .catch(err => this.error(err));
    }

    showComponent(theme) {
        const { hide } = this.props;
        const username = this.usernameFromAuthData();

        if (hide && hide.includes(ConfirmSignUp)) { return null; }

        return (
            <div className="flex_div">
        <div className="login-content" >
            <div className="logo_main">
                        <img src="/Mehan_logo.png" />
                    </div>
            <div className="logo-text text-center">NATIONAL HEALTH REGULATORY AUTHORITY</div>
            <ConfirmationDialog mode='confirmSignUp'
                open={this.state.openConfirmDialog}
                confirm_title={'User Confirmation!!'}
                confirm_message={'Are sure you want to leave the user confirmation and go back to Sign In ?'}
                button_yes={'Yes'}
                button_no={'No'}

                confirmResult={(result) => {
                    this.setState({ openConfirmDialog: false });
                    if (result) {
                        this.changeState('signIn');
                        this.inputs = {};
                    }

                }} />
            <div className="mt-3">
                <Typography gutterBottom variant="headline" className="text-center" component="h2">
                    {I18n.get('Confirm')} {I18n.get('Sign Up')}
                </Typography>

                <Grid container spacing={16}>
                    <Grid item xs={12} className="fontInfo">
                        <MessageRow>
                            {'A confirmation code has been sent to your email/sms.'}<br /><br />

                            {'Please enter the code below to verify your email/sms.If you did not receive the code,please click on Resend Code '}<br /><br />

                            {this.state.resendmsg && this.state.resendmsg.CodeDeliveryDetails &&  this.state.resendmsg.CodeDeliveryDetails.AttributeName == 'email' && <b>{'Check your mail!'}</b>} 
                            {this.state.resendmsg && this.state.resendmsg.CodeDeliveryDetails &&  this.state.resendmsg.CodeDeliveryDetails.AttributeName == 'phone_number' && <b>{'Check your mobile!'}</b>} <br />

                            {this.state.resendmsg && this.state.resendmsg.CodeDeliveryDetails &&  'Enter the code sent to ' + this.state.resendmsg.CodeDeliveryDetails.Destination} 

                        </MessageRow>
                    </Grid>
                    <Grid item xs={12}>
                        <InputRow
                            autoFocus
                            label={I18n.get('Code')}
                            theme={theme}
                            key="code"
                            name="code"
                            onChange={this.handleInputChange}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={16} className="marginCode">
                    <Grid item xs={7}>
                        <ButtonRow
                            theme={theme}
                            onClick={this.confirm}>
                            {I18n.get('Confirm')}
                        </ButtonRow>
                    </Grid>
                    <Grid item xs={5}>
                        <ButtonRow
                            theme={theme}
                            onClick={this.resend}>
                            {I18n.get('Resend Code')}
                        </ButtonRow>
                    </Grid>
                </Grid>

                {this.state.regAgain && <Grid container spacing={16} className="marginCode">
                        {"Didn't receive the OTP?"}
                        <ButtonRow style={{marginLeft:'20px'}}
                            theme={theme}
                            onClick={() => this.userExists()}>
                            {I18n.get('Register Again')}
                        </ButtonRow>
                </Grid> }

                <Grid container spacing={16}>
                    <Grid item xs={12} className="text-center">
                        <hr />
                        <Button
                            color="secondary"
                            onClick={() => this.confirmLeaving()}>
                            {I18n.get('Back to Sign In')}
                        </Button>
                    </Grid>
                </Grid>

            </div>
        </div>
        </div>
        )
    }
}
